import {Store} from "redux";

import StoreProvider from "../../redux/StoreProvider";

import RestApi from "./RestApi";
import {updateNotificationStateList} from "./ReduxApi";
import {NotificationStateList} from "./definitions/Config";

export class Poller {
    private store: Store;
    private delay = 5000;
    private intervalId: number;

    /**
     * Poller initialization:
     *    - saves the store reference
     *
     * {StoreProvider} storeProvider
     */
    init(storeProvider: StoreProvider) {
        if (!this.store) {
            this.store = storeProvider.getStore();
        }
    }

    /**
     * Starts polling from the Back-End for possibly new notifications
     * coming from the DB without reloading the page
     */
    start() {
        if (!this.intervalId) {
            this.intervalId = setInterval(() => {
                this.doPollingAction();
            }, this.delay);
        }
    }

    /**
     * Stops polling from the Back-End
     */
    stop() {
        clearInterval(this.intervalId);
        this.intervalId = null;
    }

    /**
     * Configures the time between each interval
     * New data will be polled from the Back-End each [delay] seconds
     *
     * @param {number} delay
     */
    setDelay(delay: number) {
        this.delay = delay;
    }

    /**
     * Defines polling action
     */
    private doPollingAction() {

        /** Loads the notifications from the DB */
        RestApi.getAllNotifications().then((notificationStateList: NotificationStateList) => {

            /** Notify the API to register the new state */
            this.updateStateList(notificationStateList);

        /** Stops polling when the session timed out */
        }).catch((reason) => {
            if (reason.hasOwnProperty("status") && reason.status === 403) {
                this.stop();
            }
        });
    }

    /**
     * Wraps the Redux call of the updateNotificationStateList() Action
     * N.B. This wrapper aims to make the Poller class more testable
     *
     * @param   {NotificationStateList} notificationStateList
     * @returns {Promise<void>}
     */
    private updateStateList(notificationStateList: NotificationStateList): Promise<void> {
        return this.store.dispatch(updateNotificationStateList({
            notificationStateList: notificationStateList
        }));
    }
}

export default new Poller();



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/toolbar/notificationNG/Poller.ts
 **/